import { useNavigate } from 'react-router-dom';
import AppBar from '../components/AppBar';

// Same 18px line-art icon treatment as the More grid.
const Icon = ({ children, join }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin={join ? 'round' : undefined}>
    {children}
  </svg>
);

// Tools hub — grid of calculators/what-ifs. All pure client-side, nothing saved.
const TOOLS = [
  {
    to: '/sims', label: 'Simulator', sub: 'GCI tier · commission · override',
    icon: <Icon><line x1="4" y1="8" x2="20" y2="8" /><circle cx="14" cy="8" r="2.6" fill="var(--chip)" /><line x1="4" y1="16" x2="20" y2="16" /><circle cx="8" cy="16" r="2.6" fill="var(--chip)" /></Icon>,
  },
  {
    to: '/tools/mortgage', label: 'Mortgage', wip: true, sub: 'installment · entry cost · yield',
    icon: <Icon join><path d="M3 11l9-7 9 7" /><path d="M5 10v10h14V10" /><circle cx="9.6" cy="13.6" r="1.1" /><circle cx="14.4" cy="17.4" r="1.1" /><line x1="9.4" y1="17.8" x2="14.6" y2="13.2" /></Icon>,
  },
  {
    to: '/tools/dsr', label: 'DSR', wip: true, sub: 'debt service ratio · eligibility',
    icon: <Icon><path d="M4 17a8 8 0 0 1 16 0" /><line x1="12" y1="17" x2="16.2" y2="11.4" /><circle cx="12" cy="17" r="1.3" fill="var(--chip)" /></Icon>,
  },
  {
    to: '/tools/compare', label: 'Compare', sub: '2 loans side by side · differences',
    icon: <Icon><rect x="3" y="5" width="7.5" height="14" rx="1.5" /><rect x="13.5" y="5" width="7.5" height="14" rx="1.5" /><line x1="5" y1="9.5" x2="8.5" y2="9.5" /><line x1="15.5" y1="9.5" x2="19" y2="9.5" /><line x1="5" y1="13" x2="8.5" y2="13" /><line x1="15.5" y1="13" x2="19" y2="13" /></Icon>,
  },
  {
    to: '/tools/tenancy', label: 'Tenancy', wip: true, sub: 'legal fee · stamp duty · deposits',
    icon: <Icon><rect x="5" y="3" width="14" height="18" rx="2" /><line x1="8.5" y1="8" x2="15.5" y2="8" /><line x1="8.5" y1="12" x2="15.5" y2="12" /><line x1="8.5" y1="16" x2="12.5" y2="16" /></Icon>,
  },
  {
    to: '/tools/affordability', label: 'Affordability', sub: 'budget · max property price',
    icon: <Icon><rect x="3" y="7" width="18" height="13" rx="2" /><path d="M8 7V5.5A1.5 1.5 0 0 1 9.5 4h5A1.5 1.5 0 0 1 16 5.5V7" /><circle cx="12" cy="13.5" r="2.6" /></Icon>,
  },
  {
    to: '/tools/valuation', label: 'Valuation', wip: true, sub: 'LPPEH fee scale · SST',
    icon: <Icon><path d="M12 3v18" /><path d="M5 7h14" /><path d="M7 7l-2.5 5a3 3 0 0 0 5 0L7 7z" /><path d="M17 7l-2.5 5a3 3 0 0 0 5 0L17 7z" /></Icon>,
  },
  {
    to: '/tools/lad', label: 'LAD', sub: 'late delivery · compensation',
    icon: <Icon><circle cx="12" cy="13" r="8" /><line x1="12" y1="13" x2="12" y2="8.5" /><line x1="12" y1="13" x2="15.2" y2="14.8" /><line x1="9" y1="2.5" x2="15" y2="2.5" /></Icon>,
  },
  {
    to: '/tools/refinance', label: 'Refinance', wip: true, sub: 'new loan · cash out · savings',
    icon: <Icon join><path d="M20 11a8 8 0 1 0-2.3 5.7" /><polyline points="20 6 20 11 15 11" /></Icon>,
  },
];

export default function ToolsPage() {
  const nav = useNavigate();
  // Calculators whose formulas HQ hasn't confirmed yet (wip) are HIDDEN entirely
  // until sign-off — not shown here and blocked in the Copilot. Flip `wip` off to
  // re-enable a tool once its logic is confirmed.
  const visible = TOOLS.filter((t) => !t.wip);
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <AppBar back title="Tools" sub="calculators & what-ifs · nothing saved" />
      <div className="scrx" style={{ flex: 1, overflowY: 'auto', padding: 18 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          {visible.map((t) => (
            <div key={t.to} onClick={() => nav(t.to)} style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 14, padding: 16, display: 'flex', flexDirection: 'column', gap: 10, cursor: 'pointer' }}>
              <div style={{ width: 38, height: 38, borderRadius: 11, background: 'var(--chip)', color: 'var(--primary)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{t.icon}</div>
              <div style={{ fontSize: 13, fontWeight: 600 }}>{t.label}</div>
              <div style={{ fontSize: 11.5, color: 'var(--muted)', marginTop: -6 }}>{t.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
